import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
    Package,
    Truck,
    CheckCircle,
    Clock,
    AlertCircle,
    MapPin,
    RefreshCw,
    Search,
    Loader2,
    Calendar,
    Hash,
    Layers,
    Archive,
    Map,
    XCircle,
    AlertTriangle,
    Ban,
    X,
    FileText,
    Zap,
    Navigation as NavigationIcon,
    Award,
    Truck as TruckIcon,
    PhoneCall,
    CalendarDays
} from 'lucide-react';
import { useMediaQuery } from 'react-responsive'
import { useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import FooterMob from '../components/FooterMob';
import Footer from '../components/Footer';
import NavbarMob from '../components/NavbarMob';
import Navbar from '../components/Navbar';
import order_placed from '../images/tracking/ORDER_PLACED.png'
import DelhiveryTrackingShimmer from './DelhiveryTrackingShimmer';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';

const DelhiveryTrackingComponent = () => {

    const [awb, setAwb] = useState('');
    const [mobile, setMobile] = useState('');
    const [address, setAddress] = useState('');
    const [customer, setCustomer] = useState('');
    const [updateAddressBox, setUpdateAddressBox] = useState(false);

    const [formData, setFormData] = useState({
        pincode: '',
        locality: '',

        houseNo: '',
        buildingName: '',
        street: '',
        landmark: '',
        area: '',

        city: '',
        district: '',
        state: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    const [trackingData, setTrackingData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [progressWidth, setProgressWidth] = useState('0%');
    const [isAnimating, setIsAnimating] = useState(false);
    const timelineRef = useRef(null);
    const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(null);
    const [orderPlacedDate, setOrderPlacedDate] = useState(null);

    const shipmentStatus =
        trackingData?.ShipmentData?.[0]?.Shipment?.Status

    const showUpdateAddress =
        shipmentStatus?.Instructions?.toLowerCase().includes('bad address') ||
        shipmentStatus?.Instructions?.toLowerCase().includes("incorrect address") ||
        shipmentStatus?.Instructions?.toLowerCase().includes('bad/incomplete address') 
        

    const userId = useSelector((state) => state.user.id);
    const LedCode = localStorage.getItem('LedCode');

    const [initialLoad, setInitialLoad] = useState(true);

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    const [orderId, setOrderId] = useState(null)

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isTab = useMediaQuery({ query: '(max-width: 1024px)' });

    const location = useLocation();
    const navigate = useNavigate()

    const SECRET_KEY = "shersoft_blackbaton_delhivery";

    const decryptText = (cipher) => {
        const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
    };

    useEffect(() => {
        if (updateAddressBox) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [updateAddressBox]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const enc = params.get("i");
        const plainOrderId = params.get("orderId");

        if (enc) {
            try {
                const decryptedOrderId = decryptText(decodeURIComponent(enc));
                setOrderId(decryptedOrderId);
                fetchProducts(decryptedOrderId)
                fetchTracking(decryptedOrderId);
            } catch (err) {
                console.error("Decrypt failed", err);
                setError("Invalid tracking link");
                setLoading(false);
                setInitialLoad(false);
            }
        } else if (plainOrderId) {
            const sanitized = String(plainOrderId).trim();
            setOrderId(sanitized);
            fetchProducts(sanitized);
            fetchTracking(sanitized);
        } else {
            // If no encrypted ID, show empty state
            setError("Invalid order tracking request");
            setLoading(false);
            setInitialLoad(false);
        }
    }, [location.search]);

    const parseAddress = (address) => {
        if (!address) return {};

        const parts = address.split(',').map(p => p.trim());

        if (parts.length < 4) return {};

        const [city, district, state, pincode] = parts.slice(-4);

        return { city, district, state, pincode };
    };


    const fetchTracking = async (orderId) => {
        try {
            setLoading(true);
            setError('');
            setIsFormSubmitted(true);

            const res = await fetch(
                `${apiBaseUrl}/tracking-by-orderId/${orderId}`
            );

            const data = await res.json();

            if (!res.ok || !data.success) {
                throw new Error(data.error || "Failed to fetch tracking");
            }

            const awb = data.awb;
            setAwb(awb);

            setAddress(data.address)
            const { city, district, state, pincode } = parseAddress(data.address);

            setFormData(prev => ({
                ...prev,
                city,
                district,
                state,
                pincode
            }));


            setMobile(data.mobile)
            setCustomer(data.customer)

            try {
                const response = await axios.get(`${apiBaseUrl}/track-delhivery/${awb}`);

                if (response.data.success) {
                    const newTrackingData = response.data.data;
                    setTrackingData(newTrackingData);
                    setError('');

                    // Calculate dates using the new data directly
                    const expectedDate = getExpectedDeliveryDate(newTrackingData);
                    const placedDate = getOrderPlacedDate(newTrackingData);

                    setExpectedDeliveryDate(expectedDate);
                    setOrderPlacedDate(placedDate);
                    setIsAnimating(false);

                } else {
                    setError(response.data.error || 'Failed to fetch tracking information');
                    setTrackingData(null);
                    setExpectedDeliveryDate(null);
                    setOrderPlacedDate(null);
                    resetProgress();
                }
            } catch (err) {
                console.error('Tracking error:', err);
                setError(err.response?.data?.error || 'An error occurred while tracking');
                setTrackingData(null);
                setExpectedDeliveryDate(null);
                setOrderPlacedDate(null);
                resetProgress();
            } finally {
                setLoading(false);
                setInitialLoad(false);
            }

            setIsFormSubmitted(true);
        } catch (err) {
            console.error(err);
            setError(err.message);
            setIsFormSubmitted(true);
            setExpectedDeliveryDate(null);
            setOrderPlacedDate(null);
            setInitialLoad(false);
        } finally {
            setLoading(false);
        }
    };

    const [products, setProducts] = useState([])

    const fetchProducts = async (orderId) => {
        try {
            const response = await axios.get(`${apiBaseUrl}/fetchProductsWithOrderId/BLACKBATON_2526/${orderId}/${LedCode || userId}`);

            if (response.data.success) {
                const groupedItems = response.data.groupedItems;

                // Function to check if image exists
                const checkImageExists = async (image) => {
                    try {
                        const res = await fetch(`${apiLocalUrl}/check-image/${encodeURIComponent(image)}`);
                        if (!res.ok) {
                            return false;
                        }
                        const result = await res.json();
                        return result.exists;
                    } catch (err) {
                        return false;
                    }
                };

                // Function to get modified color name (you can reuse your existing function)
                const getModifiedColor = async (color) => {
                    try {
                        // Fetch all modified colors once
                        const response = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                        const data = await response.json();
                        const modifiedColors = data.reduce((acc, item) => {
                            acc[item.db_color] = item.md_color?.toUpperCase() || '';
                            return acc;
                        }, {});
                        return modifiedColors[color] || color;
                    } catch (error) {
                        return color;
                    }
                };

                // Pre-fetch modified colors
                const modifiedColorsResponse = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                const modifiedColorsData = await modifiedColorsResponse.json();
                const modifiedColorsMap = modifiedColorsData.reduce((acc, item) => {
                    acc[item.db_color] = item.md_color?.toUpperCase() || '';
                    return acc;
                }, {});

                // Process each item to add images
                const itemsWithImages = await Promise.all(
                    groupedItems.map(async (item) => {
                        // Get sizes array (it might be an object or array, handle both)
                        let sizes = [];

                        if (Array.isArray(item.size)) {
                            // If size is already an array of objects
                            sizes = item.size;
                        } else if (item.size && typeof item.size === 'object') {
                            // If size is an object, convert to array
                            sizes = Object.entries(item.size).map(([sizeName, colors]) => ({
                                [sizeName]: colors
                            }));
                        }

                        // Process each size
                        const updatedSizes = await Promise.all(
                            sizes.map(async (sizeObj) => {
                                const sizeName = Object.keys(sizeObj)[0];
                                const colors = sizeObj[sizeName];

                                // Process each color in this size
                                const updatedColors = await Promise.all(
                                    colors.map(async (colorItem) => {
                                        // Get modified color
                                        const modifiedColor = modifiedColorsMap[colorItem.color] || colorItem.color;

                                        // Create image filename
                                        const imageName = `${item.Itemid}_${modifiedColor}.webp`;

                                        // Check if image exists
                                        const exists = await checkImageExists(imageName);

                                        // Add image URL if exists
                                        return {
                                            ...colorItem,
                                            image: exists ? `${apiLocalUrl}/uploads/${imageName}` : null,
                                            imageName: imageName,
                                            modifiedColor: modifiedColor
                                        };
                                    })
                                );

                                // Return updated size object
                                return {
                                    [sizeName]: updatedColors
                                };
                            })
                        );

                        // Return item with updated sizes and images
                        return {
                            ...item,
                            size: updatedSizes,
                            // You can also add a main image (first available image)
                            mainImage: updatedSizes.flatMap(sizeObj =>
                                Object.values(sizeObj)[0].filter(color => color.image)
                            )[0]?.image || null
                        };
                    })
                );

                // Set the data to state if you have one
                setProducts(itemsWithImages);

            } else {
                setError(response.data.error || 'Failed to fetch product information');
                return null;
            }
        } catch (err) {
            console.error('Error fetching products:', err);
            setError(err.response?.data?.error || 'An error occurred while fetching products');
            return null;
        }
    };


    const calculateTotalAmount = () => {
        return products.reduce((total, product) => {
            return total + (product.totalRate || 0);
        }, 0);
    };

    const handleTrack = async (e) => {
        e.preventDefault();

        if (!awb.trim()) {
            setError('Please enter a valid AWB number');
            return;
        }

        setLoading(true);
        setError('');
        setIsFormSubmitted(true);
        setInitialLoad(false);

        try {
            const response = await axios.get(`${apiBaseUrl}/track-delhivery/${awb}`);

            if (response.data.success) {
                const newTrackingData = response.data.data;
                setTrackingData(newTrackingData);
                setError('');

                // Calculate dates using the new data directly
                const expectedDate = getExpectedDeliveryDate(newTrackingData);
                const placedDate = getOrderPlacedDate(newTrackingData);

                setExpectedDeliveryDate(expectedDate);
                setOrderPlacedDate(placedDate);

                setIsAnimating(false);
            } else {
                setError(response.data.error || 'Failed to fetch tracking information');
                setTrackingData(null);
                setExpectedDeliveryDate(null);
                setOrderPlacedDate(null);
                resetProgress();
            }
        } catch (err) {
            console.error('Tracking error:', err);
            setError(err.response?.data?.error || 'An error occurred while tracking');
            setTrackingData(null);
            setExpectedDeliveryDate(null);
            setOrderPlacedDate(null);
            resetProgress();
        } finally {
            setLoading(false);
        }
    };


    const buildAddressString = (formData) => {
        const {
            houseNo,
            buildingName,
            street,
            landmark,
            area,
            locality
        } = formData;

        return [
            houseNo,
            buildingName,
            street,
            landmark,
            area || locality
        ]
            .filter(Boolean)
            .join(', ');
    };


    const REQUIRED_FIELDS = [
        'houseNo',
        'street',
        'area',
        'city',
        'district',
        'state',
        'pincode'
    ];

    const validateFormData = (formData) => {
        for (const field of REQUIRED_FIELDS) {
            const value = formData[field];

            if (
                value === null ||
                value === undefined ||
                value.toString().trim() === ''
            ) {
                return field;
            }
        }
        return null;
    };



    const handleUpdateAddress = async () => {

        try {

            const missingField = validateFormData(formData);

            if (missingField) {
                toast.info(`Please fill ${missingField.replace(/([A-Z])/g, ' $1')}`);
                return;
            }

            const fullAddress = buildAddressString(formData);

            const payload = {
                awb: awb,
                name: customer,
                address: fullAddress,
                city: formData.city,
                district: formData.district,
                state: formData.state,
                pin: formData.pincode,
                phone: mobile
            };

            const response = await axios.post(
                `${apiBaseUrl}/update-delhivery-address`,
                payload
            );

            if (response.data?.success) {
                toast.success("Address updated successfully");
                // console.log("Delhivery response:", response.data.data);
            } else {
                toast.error("Failed to update address");
            }

        } catch (error) {
            console.error(
                "Update address error:",
                error.response?.data || error.message
            );

            toast.error(
                error.response?.data?.error ||
                "Unable to update address. Please try again."
            );
        }
    };



    // Function to get order placed date from tracking data
    const getOrderPlacedDate = (trackingData) => {
        if (!trackingData?.ShipmentData?.[0]?.Shipment) return null;

        const shipment = trackingData.ShipmentData[0].Shipment;

        // Priority 1: Get the earliest "Manifested" scan date
        const scans = getValidScansFromData(trackingData);

        if (scans.length > 0) {
            // Find all Manifested scans
            const manifestedScans = scans.filter(scan =>
                scan.scan.toLowerCase().includes('manifest') ||
                scan.scan === 'Manifested' ||
                scan.scan === 'Order Confirmed'
            );

            // Get the earliest manifested scan (oldest scan)
            if (manifestedScans.length > 0) {
                // Sort by date (ascending - oldest first)
                manifestedScans.sort((a, b) => new Date(a.statusDateTime) - new Date(b.statusDateTime));
                return manifestedScans[0].statusDateTime;
            }

            // If no manifested scans, get the earliest scan date
            const sortedScans = [...scans].sort((a, b) => new Date(a.statusDateTime) - new Date(b.statusDateTime));
            return sortedScans[0].statusDateTime;
        }

        // Priority 2: Check for order date in shipment data
        if (shipment.OrderDate) {
            return shipment.OrderDate;
        }

        // Priority 3: Check for order date in client details
        if (shipment.ClientDetails?.OrderDate) {
            return shipment.ClientDetails.OrderDate;
        }

        // Priority 4: Check for creation date
        if (shipment.CreationDate) {
            return shipment.CreationDate;
        }

        // Priority 5: Check for manifest date specifically
        if (shipment.ManifestDate) {
            return shipment.ManifestDate;
        }

        // Priority 6: Use pickupdate as fallback
        if (shipment.PickUpDate) {
            return shipment.PickUpDate;
        }

        return null;
    };

    const getValidScansFromData = (data) => {
        if (!data?.ShipmentData?.[0]?.Shipment?.Scans) return [];

        const scans = data.ShipmentData[0].Shipment.Scans;
        const validScans = [];

        scans.forEach(scan => {
            if (scan.ScanDetail) {
                validScans.push({
                    scan: scan.ScanDetail.Scan || 'Unknown',
                    instructions: scan.ScanDetail.Instructions || '',
                    scanDateTime: scan.ScanDetail.ScanDateTime || '',
                    scanType: scan.ScanDetail.ScanType || '',
                    scannedLocation: scan.ScanDetail.ScannedLocation || '',
                    statusCode: scan.ScanDetail.StatusCode || '',
                    statusDateTime: scan.ScanDetail.StatusDateTime || '',
                    callDuration: scan.ScanDetail.call_duration,
                    geoLocation: scan.ScanDetail.geo_location
                });
            }
        });

        return validScans.reverse();
    };


    // Function to get expected delivery date from tracking data
    const getExpectedDeliveryDate = (trackingData) => {
        if (!trackingData?.ShipmentData?.[0]?.Shipment) return null;

        const shipment = trackingData.ShipmentData[0].Shipment;

        // 1: Check for expected delivery date in shipment data
        if (shipment.ExpectedDeliveryDate) {
            return shipment.ExpectedDeliveryDate;
        }

        // 2: Check for expected delivery date in scans/latest update
        const scans = getValidScansFromData(trackingData);
        if (scans.length > 0) {
            const latestScan = scans[0]; // Most recent scan

            // Try to extract date from instructions
            const instructionDateMatch = latestScan.instructions?.match(/\d{1,2}\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\s+\d{4}/i);
            if (instructionDateMatch) {
                return instructionDateMatch[0];
            }

            // Check for date in status code
            if (latestScan.statusCode?.includes('EDD')) {
                const dateMatch = latestScan.statusCode.match(/\d{4}-\d{2}-\d{2}/);
                if (dateMatch) {
                    return dateMatch[0];
                }
            }
        }

        // 3: Calculate based on pickupdate with buffer
        if (shipment.PickUpDate) {
            const pickupDate = new Date(shipment.PickUpDate);

            // Get current status from the data, not from state
            const currentStatus = getCurrentStatusFromData(trackingData);

            // Adjust delivery estimate based on current status
            let daysToAdd = 7; // Default for standard delivery

            if (currentStatus === 'Out for Delivery' || currentStatus === 'Dispatched') {
                daysToAdd = 1;
            } else if (currentStatus === 'In Transit') {
                daysToAdd = 3;
            } else if (currentStatus === 'Manifested' || currentStatus === 'Pickup Scheduled') {
                daysToAdd = 5;
            }

            const deliveryDate = new Date(pickupDate);
            deliveryDate.setDate(deliveryDate.getDate() + daysToAdd);

            // Ensure it's not a weekend
            if (deliveryDate.getDay() === 0) { // Sunday
                deliveryDate.setDate(deliveryDate.getDate() + 1); // Move to Monday
            }

            return deliveryDate.toISOString();
        }

        // 4: Calculate based on first scan date
        if (scans.length > 0) {
            const firstScanDate = new Date(scans[scans.length - 1].statusDateTime);
            const deliveryDate = new Date(firstScanDate);

            // Add business days (excluding weekends)
            let businessDaysAdded = 0;
            while (businessDaysAdded < 7) {
                deliveryDate.setDate(deliveryDate.getDate() + 1);
                if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
                    businessDaysAdded++;
                }
            }

            return deliveryDate.toISOString();
        }

        return null;
    };

    const getCurrentStatusFromData = (data) => {
        const scans = getValidScansFromData(data);
        if (scans.length > 0) {
            const latestScan = scans[0];
            if (latestScan.scan === 'Not Picked' || latestScan.statusCode === 'X-PNP') {
                return 'Order Cancelled';
            }
            return latestScan.scan;
        }
        return data?.ShipmentData?.[0]?.Shipment?.Status?.Status || 'Pending';
    };

    // Function to check if delivery date has changed
    // Function to check if delivery date has changed
    const hasDeliveryDateChanged = (trackingData) => {
        if (!expectedDeliveryDate || !trackingData) return false;

        const scans = getValidScansFromData(trackingData);
        if (scans.length < 2) return false;

        // Look for any scan mentioning a date change or delay
        const recentScans = scans.slice(0, 5); // Check last 5 scans
        const dateKeywords = [
            'expected', 'delivery', 'date', 'changed', 'updated',
            'rescheduled', 'postponed', 'delayed', 'delay', 'revised',
            'new date', 'expected date', 'edd'
        ];

        // Also check if any scan mentions a specific date that's different from current expected date
        const currentExpectedDate = new Date(expectedDeliveryDate);

        for (const scan of recentScans) {
            const instructions = scan.instructions?.toLowerCase() || '';
            const scanDate = scan.statusDateTime;

            // Check for date change keywords
            if (dateKeywords.some(keyword => instructions.includes(keyword))) {
                return true;
            }

            // Check if scan mentions a specific date in instructions
            const datePatterns = [
                /\d{1,2}\s+(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\s+\d{4}/i,
                /\d{1,2}[-/]\d{1,2}[-/]\d{4}/,
                /\d{4}[-/]\d{1,2}[-/]\d{1,2}/
            ];

            for (const pattern of datePatterns) {
                const match = instructions.match(pattern);
                if (match) {
                    try {
                        const mentionedDate = new Date(match[0]);
                        if (!isNaN(mentionedDate.getTime())) {
                            // If mentioned date is different from current expected date
                            if (Math.abs(mentionedDate - currentExpectedDate) > 86400000) { // 1 day difference
                                return true;
                            }
                        }
                    } catch (error) {
                        // Continue checking other patterns
                    }
                }
            }
        }

        return false;
    };

    // Function to calculate expected delivery date
    const calculateExpectedDeliveryDate = (data) => {
        return getExpectedDeliveryDate(data);
    };

    // Flipkart-style steps with icons and colors
    const trackingSteps = [
        { id: 'manifested', label: 'Order Placed', icon: <CheckCircle className="w-5 h-5" />, color: 'bg-white' },
        { id: 'pickup', label: 'Pickup Scheduled', icon: <Package className="w-5 h-5" />, color: 'bg-blue-500' },
        { id: 'transit', label: 'In Transit', icon: <Truck className="w-5 h-5" />, color: 'bg-blue-500' },
        { id: 'out_for_delivery', label: 'Out for Delivery', icon: <TruckIcon className="w-5 h-5" />, color: 'bg-purple-500' },
        { id: 'delivered', label: 'Delivered', icon: <CheckCircle className="w-5 h-5" />, color: 'bg-green-500' }
    ];

    // Status configuration with proper step mapping
    const statusConfig = {
        'Manifested': {
            color: 'bg-blue-100 border-blue-300 text-blue-800',
            icon: <Package className="w-6 h-6" />,
            description: 'Order confirmed and shipment info uploaded',
            category: 'origin',
            step: 0,
            progress: 20
        },
        'In Transit': {
            color: 'bg-indigo-100 border-indigo-300 text-indigo-800',
            icon: <Truck className="w-6 h-6" />,
            description: 'Shipment is moving between facilities',
            category: 'transit',
            step: 2,
            progress: 50
        },
        'Delivered': {
            color: 'bg-green-100 border-green-300 text-green-800',
            icon: <CheckCircle className="w-6 h-6" />,
            description: 'Successfully delivered to recipient',
            category: 'delivery',
            step: 4,
            progress: 100
        },
        'Pending': {
            color: 'bg-yellow-100 border-yellow-300 text-yellow-800',
            icon: <Clock className="w-6 h-6" />,
            description: 'Waiting for processing',
            category: 'processing',
            step: 0,
            progress: 10
        },
        'Dispatched': {
            color: 'bg-purple-100 border-purple-300 text-purple-800',
            icon: <Truck className="w-6 h-6" />,
            description: 'Out for delivery',
            category: 'delivery',
            step: 3,
            progress: 75
        },
        'Out for Delivery': {
            color: 'bg-purple-100 border-purple-300 text-purple-800',
            icon: <TruckIcon className="w-6 h-6" />,
            description: 'On its way to delivery address',
            category: 'delivery',
            step: 3,
            progress: 80
        },
        'Cancelled': {
            color: 'bg-red-100 border-red-300 text-red-800',
            icon: <XCircle className="w-6 h-6" />,
            description: 'Shipment has been cancelled',
            category: 'cancelled',
            step: -1,
            progress: 0
        },
        'Canceled': {
            color: 'bg-red-100 border-red-300 text-red-800',
            icon: <XCircle className="w-6 h-6" />,
            description: 'Shipment has been cancelled',
            category: 'cancelled',
            step: -1,
            progress: 0
        },
        'RTO': {
            color: 'bg-orange-100 border-orange-300 text-orange-800',
            icon: <AlertTriangle className="w-6 h-6" />,
            description: 'Return to origin initiated',
            category: 'cancelled',
            step: -1,
            progress: 0
        },
        'Undelivered': {
            color: 'bg-orange-100 border-orange-300 text-orange-800',
            icon: <Ban className="w-6 h-6" />,
            description: 'Shipment could not be delivered',
            category: 'cancelled',
            step: -1,
            progress: 0
        },
        'Rejected': {
            color: 'bg-red-100 border-red-300 text-red-800',
            icon: <XCircle className="w-6 h-6" />,
            description: 'Shipment was rejected',
            category: 'cancelled',
            step: -1,
            progress: 0
        },
        'Not Picked': {
            color: 'bg-red-100 border-red-300 text-red-800',
            icon: <X className="w-6 h-6" />,
            description: 'Order was cancelled - not picked up',
            category: 'cancelled',
            step: -1,
            progress: 0
        },
        'Not Picked Up': {
            color: 'bg-red-100 border-red-300 text-red-800',
            icon: <X className="w-6 h-6" />,
            description: 'Order was cancelled - not picked up',
            category: 'cancelled',
            step: -1,
            progress: 0
        },
        'Order Cancelled': {
            color: 'bg-red-100 border-red-300 text-red-800',
            icon: <XCircle className="w-6 h-6" />,
            description: 'Order has been cancelled',
            category: 'cancelled',
            step: -1,
            progress: 0
        }
    };

    const formatExpectedDate = (dateString) => {
        if (!dateString) return 'Not available';

        try {
            // Handle different date formats
            let date;

            // If it's already a Date object
            if (dateString instanceof Date) {
                date = dateString;
            }
            // If it's in ISO format
            else if (dateString.includes('T') || dateString.includes('-')) {
                date = new Date(dateString);
            }
            // If it's in "25 Dec 2024" format
            else {
                date = new Date(dateString);
            }

            // Check if date is valid
            if (isNaN(date.getTime())) {
                return dateString; // Return original string if can't parse
            }

            return date.toLocaleDateString('en-IN', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        } catch (error) {
            console.error('Error formatting date:', error);
            return dateString; // Return original if formatting fails
        }
    };

    const isExpectedDateValid = (dateString) => {
        if (!dateString) return false;
        const expectedDate = new Date(dateString);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expectedDate.setHours(0, 0, 0, 0);
        return expectedDate >= today;
    };



    const formatOrderPlacedDate = (dateString) => {
        if (!dateString) return 'Not available';

        try {
            let date;

            if (dateString instanceof Date) {
                date = dateString;
            } else if (dateString.includes('T') || dateString.includes('-')) {
                date = new Date(dateString);
            } else {
                date = new Date(dateString);
            }

            if (isNaN(date.getTime())) {
                return dateString;
            }

            return date.toLocaleDateString('en-IN', {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        } catch (error) {
            console.error('Error formatting order date:', error);
            return dateString;
        }
    };

    // Calculate progress based on current status
    const calculateProgress = () => {
        const currentStatus = getCurrentStatus();
        const statusInfo = statusConfig[currentStatus];

        if (statusInfo) {
            const step = statusInfo.step;
            const progress = statusInfo.progress || ((step + 1) / trackingSteps.length) * 100;

            let excess = 1

            if (progress == 100) {
                excess = 0
            } else {
                excess = 1
            }

            setCurrentStep(Math.max(0, step)); // Ensure step is not negative
            setProgressWidth(`${progress + excess}%`);
        } else {
            // Default progress for unknown status
            setCurrentStep(0);
            setProgressWidth('10%');
        }
    };

    // Reset progress
    const resetProgress = () => {
        setCurrentStep(0);
        setProgressWidth('0%');
        setIsAnimating(false);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            weekday: 'short',
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const formatTimeAgo = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffDays > 0) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
        if (diffHours > 0) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
        if (diffMins > 0) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
        return 'Just now';
    };

    const resetForm = () => {
        setAwb('');
        setTrackingData(null);
        setError('');
        setIsFormSubmitted(false);
        setExpectedDeliveryDate(null);
        setOrderPlacedDate(null);
        resetProgress();
    };
    // Function to get all valid scans from the data
    const getValidScans = () => {
        if (!trackingData?.ShipmentData?.[0]?.Shipment?.Scans) return [];

        const scans = trackingData.ShipmentData[0].Shipment.Scans;
        const validScans = [];

        // Filter only scans that have ScanDetail
        scans.forEach(scan => {
            if (scan.ScanDetail) {
                validScans.push({
                    scan: scan.ScanDetail.Scan || 'Unknown',
                    instructions: scan.ScanDetail.Instructions || '',
                    scanDateTime: scan.ScanDetail.ScanDateTime || '',
                    scanType: scan.ScanDetail.ScanType || '',
                    scannedLocation: scan.ScanDetail.ScannedLocation || '',
                    statusCode: scan.ScanDetail.StatusCode || '',
                    statusDateTime: scan.ScanDetail.StatusDateTime || '',
                    callDuration: scan.ScanDetail.call_duration,
                    geoLocation: scan.ScanDetail.geo_location
                });
            }
        });

        return validScans.reverse(); // Reverse to show latest first
    };

    const getCurrentStatus = () => {
        const scans = getValidScans();
        if (scans.length > 0) {
            const latestScan = scans[0];

            if (latestScan.scan === 'Not Picked' || latestScan.statusCode === 'X-PNP') {
                return 'Order Cancelled';
            }

            return latestScan.scan;
        }
        return trackingData?.ShipmentData?.[0]?.Shipment?.Status?.Status || 'Pending';
    };

    // Check if shipment is delivered
    const isShipmentDelivered = () => {
        return getCurrentStatus() === 'Delivered';
    };

    // Check if shipment is cancelled
    const isShipmentCancelled = () => {
        const scans = getValidScans();
        if (scans.length > 0) {
            const latestScan = scans[0];
            const scanText = latestScan.scan.toLowerCase();
            const statusCode = latestScan.statusCode || '';

            return scanText.includes('cancel') ||
                scanText.includes('rto') ||
                scanText.includes('undelivered') ||
                scanText.includes('rejected') ||
                scanText.includes('not picked') ||
                statusCode.includes('X-PNP') ||
                statusCode.includes('PNP');
        }
        return false;
    };

    // Get latest update for EACH status type
    const getLatestUpdateForEachStatus = () => {
        const scans = getValidScans();
        const latestByStatus = {};

        // Process all scans to get the latest one for each status type
        scans.forEach(scan => {
            const statusType = scan.scan;
            const currentUpdate = latestByStatus[statusType];

            if (!currentUpdate || new Date(scan.statusDateTime) > new Date(currentUpdate.statusDateTime)) {
                latestByStatus[statusType] = scan;
            }
        });

        // Convert to array and sort by time (most recent first)
        const updatesArray = Object.values(latestByStatus);
        updatesArray.sort((a, b) => new Date(b.statusDateTime) - new Date(a.statusDateTime));

        return updatesArray;
    };

    // Check if scan type is cancelled
    const isCancelledScanType = (scanType) => {
        const lowerType = scanType.toLowerCase();
        return lowerType.includes('cancel') ||
            lowerType.includes('not picked') ||
            lowerType.includes('rto') ||
            lowerType.includes('undelivered') ||
            lowerType.includes('rejected');
    };

    const getStatusIcon = (scanStatus) => {
        const lowerStatus = scanStatus.toLowerCase();

        if (isCancelledScanType(scanStatus)) return <XCircle className="w-5 h-5 text-red-600" />;
        if (lowerStatus.includes('rto')) return <AlertTriangle className="w-5 h-5 text-orange-600" />;
        if (lowerStatus.includes('undelivered')) return <Ban className="w-5 h-5 text-red-600" />;
        if (lowerStatus.includes('rejected')) return <XCircle className="w-5 h-5 text-red-600" />;

        if (scanStatus === 'In Transit') return <Truck className="w-5 h-5 text-[#555555]" />;
        if (scanStatus === 'Delivered') return <CheckCircle className="w-5 h-5 text-[#555555]" />;
        if (scanStatus === 'Dispatched' || scanStatus === 'Out for Delivery') return <TruckIcon className="w-5 h-5 text-[#555555]" />;
        if (scanStatus === 'Manifested') return <Package className="w-5 h-5 text-[#555555]" />;
        if (scanStatus === 'Pending') return <Clock className="w-5 h-5 text-[#555555]" />;

        return <RefreshCw className="w-6 h-6 text-gray-600" />;
    };

    const getStatusColor = (scanStatus) => {
        if (isCancelledScanType(scanStatus)) return 'bg-red-50 border-red-200 text-red-800';
        if (scanStatus.includes('rto')) return 'bg-orange-50 border-orange-200 text-orange-800';
        if (scanStatus.includes('undelivered')) return 'bg-orange-50 border-orange-200 text-orange-800';

        if (scanStatus === 'In Transit') return 'bg-blue-50 border-blue-200 text-blue-800';
        if (scanStatus === 'Delivered') return 'bg-green-50 border-green-200 text-green-800';
        if (scanStatus === 'Dispatched' || scanStatus === 'Out for Delivery') return 'bg-purple-50 border-purple-200 text-purple-800';
        if (scanStatus === 'Manifested') return 'bg-blue-50 border-blue-200 text-blue-800';
        if (scanStatus === 'Pending') return 'bg-yellow-50 border-yellow-200 text-yellow-800';

        return 'bg-gray-50 border-gray-200 text-gray-800';
    };

    // Get total scan count
    const getTotalScans = () => {
        return getValidScans().length;
    };

    // Get unique locations count
    const getUniqueLocations = () => {
        const scans = getValidScans();
        const locations = new Set(scans.map(scan => scan.scannedLocation));
        return locations.size;
    };

    // Get unique scan types
    const getUniqueScanTypes = () => {
        const scans = getValidScans();
        const types = new Set(scans.map(scan => scan.scan));
        return Array.from(types);
    };

    // Get cancellation reason from scans
    const getCancellationReason = () => {
        const scans = getValidScans();
        const cancelledScans = scans.filter(scan => isCancelledScanType(scan.scan));

        if (cancelledScans.length > 0) {
            // Try to find the most descriptive instruction
            const reasons = cancelledScans
                .map(scan => scan.instructions)
                .filter(instruction => instruction && instruction.trim().length > 0);

            if (reasons.length > 0) {
                return reasons[0];
            }

            return cancelledScans[0].scan === 'Not Picked' ? 'Shipment not received from client' : 'Order cancelled';
        }

        return 'Reason not specified';
    };

    // Animation for moving bubble
    useEffect(() => {
        if (!timelineRef.current || isShipmentDelivered() || isShipmentCancelled()) return;

        if (isAnimating) {
            const timelineElement = timelineRef.current;
            const steps = timelineElement.querySelectorAll('.timeline-step');

            if (steps.length === 0) return;

            const interval = setInterval(() => {
                steps.forEach((step, index) => {
                    if (index === currentStep) {
                        step.classList.add('animate-pulse', 'scale-110');
                    } else {
                        step.classList.remove('animate-pulse', 'scale-110');
                    }
                });
            }, 1500);

            return () => clearInterval(interval);
        }
    }, [currentStep, isAnimating, isShipmentDelivered, isShipmentCancelled]);

    useEffect(() => {
        calculateProgress()
    }, [trackingData])

    const getDeliveredDate = () => {
        if (!trackingData || !isShipmentDelivered()) return null;

        const scans = getValidScans();
        const deliveredScan = scans.find(scan => scan.scan === 'Delivered');

        if (deliveredScan && deliveredScan.statusDateTime) {
            return deliveredScan.statusDateTime;
        }

        return expectedDeliveryDate; // Fallback to expected date
    };

    const FlipkartProgressTrackerMobile = () => {
        const showLive = !isShipmentDelivered() && !isShipmentCancelled() && currentStep >= 0;

        return (
            <div className="w-full flex flex-col gap-3 p-5 border-2 border-[#F0F0F0] font-montserrat">

                <div className='w-full font-[600] flex flex-row text-nowrap'>
                    <span className='w-full font-semibold text-left'>Status</span>
                    {isShipmentDelivered() ? (
                        <span className="px-3 py-1 text-[.8rem] bg-[#F6F6F6] text-[#191C1F] rounded-full text-sm font-medium">
                            Delivered
                        </span>
                    ) : isShipmentCancelled() ? (
                        <span className="px-3 py-1 bg-[#F6F6F6] text-[#191C1F] rounded-full text-sm font-medium">
                            Cancelled
                        </span>
                    ) : isExpectedDateValid(expectedDeliveryDate) ? (
                        <span className="px-3 py-1 bg-[#F6F6F6] text-[#191C1F] rounded-full text-sm font-medium">
                            On track
                        </span>
                    ) : (
                        <span className="px-3 py-1 bg-[#F6F6F6] text-[#191C1F] rounded-full text-sm font-medium">
                            Delayed
                        </span>
                    )}
                </div>

                <div className="flex flex-col gap-4 relative ">


                    {/* Vertical Line */}
                    <div className="absolute left-3 top-0 bottom-0 w-[2px] bg-gray-200" />

                    {trackingSteps.map((step, index) => {
                        const isActive = index <= currentStep;
                        const isCurrent = index === currentStep;
                        const isCancelled = isShipmentCancelled();

                        return (
                            <div key={step.id} className="flex items-center gap-4 relative">

                                {/* Step Circle */}
                                <div
                                    className={`w-7 h-7 rounded-full flex items-center justify-center z-10
                                        ${isActive
                                            ? isCancelled
                                                ? 'bg-red-500'
                                                : 'bg-black'
                                            : 'bg-gray-200'
                                        }`}
                                >
                                    {React.cloneElement(step.icon, {
                                        className: `w-4 h-4 ${isActive ? 'text-white' : 'text-gray-400'
                                            }`
                                    })}
                                </div>

                                {/* Label */}
                                <div className="flex flex-col">
                                    <span
                                        className={`text-sm font-medium
                                            ${isActive
                                                ? isCancelled
                                                    ? 'text-red-700'
                                                    : 'text-gray-900'
                                                : 'text-gray-500'
                                            }`}
                                    >
                                        {step.label}
                                    </span>
                                </div>

                                {/* Live Ping */}
                                {isCurrent && showLive && (
                                    <span className="absolute left-[6px] top-[6px] w-2 h-2 bg-black rounded-full animate-ping" />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    // Flipkart-style progress tracker component
    const FlipkartProgressTracker = () => {
        const currentStatus = getCurrentStatus();
        const statusInfo = statusConfig[currentStatus];
        const showLive = !isShipmentDelivered() && !isShipmentCancelled() && currentStep >= 0;

        return (
            <div className="p-5 border-2 border-[#F0F0F0] font-montserrat">

                <div className="bg-white flex flex-col gap-2 text-left rounded-xl font-montserrat">
                    <div className='font-[600] flex flex-row text-nowrap'>
                        <span className='w-full font-semibold'>Tracking Status</span>
                        {isShipmentDelivered() ? (
                            <span className="px-3 py-1 text-[.8rem] bg-[#F6F6F6] text-[#191C1F] rounded-full text-sm font-medium">
                                Delivered
                            </span>
                        ) : isShipmentCancelled() ? (
                            <span className="px-3 py-1 bg-[#F6F6F6] text-[#191C1F] rounded-full text-sm font-medium">
                                Cancelled
                            </span>
                        ) : isExpectedDateValid(expectedDeliveryDate) ? (
                            <span className="px-3 py-1 bg-[#F6F6F6] text-[#191C1F] rounded-full text-sm font-medium">
                                On track
                            </span>
                        ) : (
                            <span className="px-3 py-1 bg-[#F6F6F6] text-[#191C1F] rounded-full text-sm font-medium">
                                Delayed
                            </span>
                        )}
                    </div>


                    {isShipmentDelivered() ? (
                        <div className='w-full flex flex-row text-nowrap font-[400] text-sm'>
                            <span className='w-full'>
                                Delivered on {formatExpectedDate(getDeliveredDate() || expectedDeliveryDate)}
                            </span>
                        </div>
                    ) : expectedDeliveryDate && !isShipmentCancelled() && trackingData && (
                        <div className='w-full flex flex-row text-nowrap font-[400] text-sm'>
                            <span className='w-full'>Order expected arrival {formatExpectedDate(expectedDeliveryDate)}</span>
                        </div>
                    )}

                </div>
                <div className=" rounded-2xl p-5 ">



                    {/* Progress bar with moving bubble */}
                    <div className="relative">
                        <div className="absolute top-1/2 left-0 right-0 h-1 bg-gray-200 rounded-full transform -translate-y-1/2"></div>
                        <div
                            className="absolute top-1/2 left-0 h-1 bg-black rounded-full transform -translate-y-1/2 transition-all duration-1000 ease-out"
                            style={{ width: progressWidth }}
                        ></div>

                        {/* Moving bubble animation */}
                        {/* {showLive && (
                            <div
                                className="absolute top-1/2 transform -translate-y-1/2 transition-all duration-1000 ease-out z-10"
                                style={{ left: `calc(${progressWidth} - 12px)` }}
                            >
                                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center shadow-lg animate-bounce">
                                    <NavigationIcon className="w-4 h-4 text-white" />
                                </div>
                            </div>
                        )} */}

                        {/* Timeline steps */}
                        <div className="relative flex justify-between w-full " ref={timelineRef}>
                            {trackingSteps.map((step, index) => {
                                const isActive = index <= currentStep;
                                const isCurrent = index === currentStep;
                                const isCancelled = isShipmentCancelled();
                                const isDelivered = isShipmentDelivered();

                                const alignment =
                                    index === 0
                                        ? "items-start"
                                        : index === trackingSteps.length - 1
                                            ? "items-end"
                                            : "items-center";

                                const margin =
                                    index === 0
                                        ? "mr-3"
                                        : index === trackingSteps.length - 1
                                            ? "ml-3"
                                            : "";

                                return (
                                    <div key={step.id} className={`flex flex-col ${alignment}  relative z-10 mt-6`}>
                                        <div className={`timeline-step w-8 h-8 rounded-full flex items-center justify-center mb-3 transition-all duration-300 ${isActive
                                            ? isCurrent && showLive
                                                ? 'bg-black'
                                                : isCancelled
                                                    ? 'bg-red-500'
                                                    : isDelivered && index === trackingSteps.length - 1
                                                        ? 'bg-black shadow-md'
                                                        : 'bg-black shadow-md'
                                            : isCancelled
                                                ? 'bg-red-200'
                                                : 'bg-gray-200'
                                            }`}>
                                            <div className={`w-6 h-6 rounded-full flex items-center justify-center ${isActive
                                                ? isCancelled
                                                    ? 'bg-red-100'
                                                    : 'bg-black'
                                                : 'bg-gray-100'
                                                }`}>
                                                {React.cloneElement(step.icon, {
                                                    className: `w-4 h-4 ${isActive
                                                        ? isCancelled
                                                            ? 'text-red-600'
                                                            : 'text-white'
                                                        : 'text-gray-400'
                                                        }`
                                                })}
                                            </div>
                                        </div>
                                        <span className={`text-xs font-medium  text-center ${isActive
                                            ? isCancelled
                                                ? 'text-red-700'
                                                : 'text-gray-900'
                                            : 'text-gray-500'
                                            }`}>
                                            <span className=''>{step.label}</span>
                                        </span>
                                        {isCurrent && showLive && (
                                            <div className="absolute top-0 right-1 w-2 h-2 bg-black rounded-full animate-ping"></div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Current status display */}
                    {/* <div className="bg-white rounded-xl p-4 border border-blue-100">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div className={`p-2 rounded-lg ${isShipmentCancelled()
                                    ? 'bg-red-50'
                                    : isShipmentDelivered()
                                        ? 'bg-green-50'
                                        : 'bg-blue-50'
                                    }`}>
                                    {statusInfo?.icon || <Package className="w-5 h-5 text-blue-600" />}
                                </div>
                                <div>
                                    <p className="font-semibold text-gray-900">{currentStatus}</p>
                                    <p className="text-sm text-gray-600">
                                        {statusInfo?.description || 'Tracking information available'}
                                    </p>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="text-sm text-gray-500">Last Updated</p>
                                <p className="font-semibold text-gray-900">
                                    {formatDate(trackingData?.ShipmentData?.[0]?.Shipment?.Status?.StatusDateTime)}
                                </p>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        );
    };

    // Render latest update for EACH status type
    const renderLatestStatusUpdates = () => {
        const latestUpdates = getLatestUpdateForEachStatus();
        const statusTypes = getUniqueScanTypes();

        return (
            <div className="flex flex-col gap-5 p-5 pt-3 pb-0 font-montserrat">
                {statusTypes.map((statusType, index) => {
                    // Find the latest update for this status type
                    const latestUpdate = latestUpdates.find(update => update.scan === statusType);

                    if (!latestUpdate) return null;

                    const isCancelled = isCancelledScanType(statusType);
                    const isDelivered = statusType === 'Delivered';

                    return (
                        <div key={index} className={`w-full border-b pb-5`}>
                            <div className="w-full flex items-center gap-4">
                                {/* Status Icon */}
                                <div className={`bg-[#F0F0F0] p-3 rounded-full hidden md:block`}>
                                    {getStatusIcon(statusType)}
                                </div>

                                {/* Status Info */}
                                <div className="w-full flex-col text-nowrap break-words text-[.8rem] text-[#77878F]">
                                    {/* <div className="flex flex-wrap items-center gap-3 mb-2">
                                            <span className={`px-3 py-1 rounded-full text-sm font-semibold ${isCancelled
                                                ? 'bg-red-100 border-red-200 text-red-800'
                                                : isDelivered
                                                    ? 'bg-green-100 border-green-200 text-green-800'
                                                    : 'bg-blue-100 border-blue-200 text-blue-800'
                                                }`}>
                                                {statusType}
                                            </span>
                                        </div> */}

                                    <span className="w-full text-left flex items-center gap-1">
                                        {/* <Calendar className="w-4 h-4" /> */}

                                        <span className='md:w-full text-wrap break-words'>{formatDate(latestUpdate.statusDateTime)} </span>
                                        <span className='text-[.75rem] hidden md:block'>{formatTimeAgo(latestUpdate.statusDateTime)}</span>
                                    </span>

                                    <div className='md:w-full text-left text-wrap break-words'>
                                        <p className={`text-[#191C1F] `}>
                                            {latestUpdate.instructions || `${statusType} update`}
                                        </p>
                                    </div>

                                    <span className="flex w-full text-left items-center gap-1">
                                        {/* <MapPin className="w-4 h-4" /> */}
                                        <span className='md:w-full text-wrap break-words'>{latestUpdate.scannedLocation || 'Location not available'}</span>
                                        {latestUpdate.callDuration && (
                                            <span className='hidden md:flex flex-row justify-center items-center gap-2 text-[.75rem]'>
                                                <PhoneCall className="w-[.7rem] h-[.7rem]" />
                                                Call: {latestUpdate.callDuration}s
                                            </span>
                                        )}
                                    </span>

                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    const formatSizes = (sizes = []) => {
        return sizes.map((sizeObj, idx) => {
            const sizeKey = Object.keys(sizeObj)[0]; // e.g., "L", "XL"
            const items = sizeObj[sizeKey] || [];

            return (
                <div key={idx} className="mb-1">
                    {/* Size label */}
                    <span className="font-semibold text-gray-800 mr-1">
                        {sizeKey} :
                    </span>

                    {/* Colors */}
                    {items.map((it, i) => (
                        <span key={i} className="text-gray-600 text-wrap break-words">
                            <span className="text-gray-700">{it.color}</span>
                            <span className="font-medium text-black"> - {it.quantity}</span>
                            {i !== items.length - 1 && <span>, </span>}
                        </span>
                    ))}
                </div>
            );
        });
    };


    if (initialLoad) {
        return <DelhiveryTrackingShimmer isMobile={isMobile} />;
    }

    return (
        <div className='min-h-screen flex flex-col '>
            <div className='h-max'>
                {isMobile ? <NavbarMob /> : <Navbar />}
            </div>

            <div className="w-full h-auto flex flex-col lg:gap-12 gap-6 lg:mt-[175px] md:mt-[175px] mt-[60px]">
                <div className="w-full">

                    <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
                        {/* Search Section */}
                        {/* <div className="p-6 md:p-8 ">
                            <div className="max-w-3xl mx-auto">
                                <form onSubmit={handleTrack} className="space-y-4">
                                    <div className="flex flex-col md:flex-row gap-4">
                                        <div className="flex-1 relative">
                                            <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                                                <Search className="w-5 h-5 text-gray-400" />
                                            </div>
                                            <input
                                                type="text"
                                                value={awb}
                                                onChange={(e) => {
                                                    setAwb(e.target.value);
                                                    setError('');
                                                }}
                                                placeholder="Enter Delhivery AWB Number (e.g., 123456789012)"
                                                className="w-full pl-12 pr-4 py-4 text-lg border-2 border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all duration-200 disabled:bg-gray-50"
                                                disabled={loading}
                                            />
                                        </div>
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 min-w-[180px] shadow-lg hover:shadow-xl"
                                        >
                                            {loading ? (
                                                <>
                                                    <Loader2 className="w-5 h-5 animate-spin" />
                                                    Tracking...
                                                </>
                                            ) : (
                                                <>
                                                    <Search className="w-5 h-5" />
                                                    Track Shipment
                                                </>
                                            )}
                                        </button>
                                    </div>
                                    {error && !isFormSubmitted && (
                                        <div className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-red-600">
                                            <AlertCircle className="w-5 h-5" />
                                            <span>{error}</span>
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div> */}



                        {/* Content Area */}
                        <div className="p-6 md:p-8">
                            {error && !trackingData && (
                                <div className="mb-8 p-6 bg-gray-50 border border-gray-200 rounded-2xl text-center">
                                    <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-black text-white flex items-center justify-center">
                                        <AlertCircle className="w-6 h-6" />
                                    </div>
                                    <h3 className="font-bold text-xl text-gray-900">Invalid Order</h3>
                                    <p className="text-gray-600 mt-2">
                                        We could not find tracking details for this order ID.
                                    </p>
                                    <button
                                        type="button"
                                        className="mt-5 px-5 py-2.5 bg-black text-white rounded-lg font-semibold"
                                        onClick={() => navigate('/account')}
                                    >
                                        Go To My Orders
                                    </button>
                                </div>
                            )}

                            {/* Error Message */}
                            {error && isFormSubmitted && trackingData && (
                                <div className="mb-8 p-6 bg-red-50 border-2 border-red-200 rounded-2xl">
                                    <div className="flex items-center gap-4">
                                        <div className="p-3 bg-white rounded-xl">
                                            <AlertCircle className="w-8 h-8 text-red-500" />
                                        </div>
                                        <div>
                                            <h3 className="font-bold text-lg text-red-800">Unable to Track Shipment</h3>
                                            <p className="text-red-600 mt-1">{error}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Tracking Results */}
                            {trackingData && (
                                <div className="w-full space-y-5 animate-fadeIn font-montserrat">
                                    {/* Flipkart-style Progress Tracker */}
                                    <div className='w-full flex flex-col text-nowrap'>
                                        <div className='relative bg-[#F6F6F6] flex flex-col gap-2 p-5 font-montserrat w-full text-left'>
                                            <div className='w-full flex flex-col md:flex-row justify-center items-start md:justify-start md:items-center gap-2 md:gap-5 text-[#191C1F] font-[500] text-[1rem]'>
                                                <span className=''>#{orderId}</span>
                                                <div className='flex flex-row gap-5'>
                                                    {showUpdateAddress && (
                                                        <div className='text-sm px-2 py-1 cursor-pointer bg-gray-300 rounded-md' onClick={() => setUpdateAddressBox(true)}>Update address</div>
                                                    )}
                                                    {/* <div className='text-sm px-2 py-1 cursor-pointer bg-gray-300 rounded-md'>Cancel</div> */}
                                                </div>
                                            </div>
                                            <div className='w-full h-max flex flex-row justify-end items-end text-[#475156] text-[0.875rem]'>
                                                <div className='w-full flex flex-col md:flex-row gap-2 '>
                                                    <span>{products.length} Products</span>
                                                    {/* <span>•</span> */}
                                                    <span className='hidden md:block'>●</span>
                                                    {orderPlacedDate && (
                                                        <span className='break-words text-wrap'>Order Placed in {formatOrderPlacedDate(orderPlacedDate)}</span>
                                                    )}
                                                </div>
                                                <span className=' text-gray-800 rounded-full text-[.7rem] font-medium'>{formatTimeAgo(orderPlacedDate)}</span>
                                            </div>
                                            <div className='hidden md:block absolute right-5 top-5 font-bold  cursor-pointer rounded-full'
                                                onClick={() => navigate('/account')}
                                            >
                                                ✕
                                            </div>
                                            <div className='block md:hidden absolute right-5 top-5 font-bold p-2 px-3 cursor-pointer hover:bg-gray-200 rounded-full'
                                                onClick={() => navigate('/myorders')}
                                            >
                                                ✕
                                            </div>
                                        </div>
                                        <div className="hidden md:block">
                                            <FlipkartProgressTracker />
                                        </div>

                                        <div
                                            className={`block md:hidden ${isShipmentCancelled()
                                                ? 'opacity-75 pointer-events-none'
                                                : ''
                                                }`}
                                        >
                                            <FlipkartProgressTrackerMobile />
                                        </div>
                                    </div>

                                    {/* Tracking History Section */}
                                    <div className={`w-full flex flex-col text-nowrap border-2 border-[#F0F0F0] font-montserrat`}>
                                        <div className='w-full font-semibold text-left p-5'>
                                            Order Timeline
                                        </div>
                                        {renderLatestStatusUpdates()}
                                    </div>

                                    <div className={`w-full flex flex-col text-nowrap border-2 border-[#F0F0F0] font-montserrat`}>
                                        <div className='w-full font-semibold text-left p-5'>
                                            Shipment Details
                                        </div>
                                        <div className='w-full flex flex-col text-left p-5 pt-2 gap-2 text-[.95rem] '>
                                            <span>Courier :  Delhivery</span>
                                            <span className='text-wrap break-words'>Tracking Number : #{trackingData.ShipmentData?.[0]?.Shipment?.AWB || awb}</span>
                                        </div>
                                    </div>

                                    <div className={`w-full flex flex-col break-words md:text-nowrap border-2 border-[#F0F0F0] font-montserrat`}>
                                        <div className='w-full font-semibold text-left p-5'>
                                            Order Information
                                        </div>
                                        <div className='w-full flex flex-col text-left p-5 py-2 gap-2 text-[.9rem] '>
                                            <div className='w-full flex flex-row gap-2'>
                                                <span className='w-full'>Order Date</span>
                                                <span className='text-right'>{formatOrderPlacedDate(orderPlacedDate)}</span>
                                            </div>

                                            {isShipmentDelivered() ? (
                                                <div className='w-full flex flex-row gap-2'>
                                                    <span className='w-full'>Delivered on</span>
                                                    <span className='text-right'>{formatExpectedDate(getDeliveredDate() || expectedDeliveryDate)}</span>
                                                </div>
                                            ) : expectedDeliveryDate && !isShipmentCancelled() && trackingData && (
                                                <div className='w-full flex flex-row gap-2'>
                                                    <span className='w-full'>Estimate Delivery</span>
                                                    <span className='text-right'>{formatExpectedDate(expectedDeliveryDate)}</span>
                                                </div>
                                            )}

                                            <div className='w-full flex flex-row gap-2'>
                                                <span className='w-full'>Payment Method</span>
                                                <span className='text-[#05B81A]'>Prepaid</span>
                                            </div>
                                        </div>
                                        <div className='w-full flex flex-row text-nowrap font-semibold text-left p-5 border-t border-[#F6F6F6]'>
                                            <span className='w-full'>Total Amount</span>
                                            <span>Rs. {calculateTotalAmount().toFixed(2)}</span>
                                        </div>
                                    </div>

                                    <div className={`w-full flex flex-col border-2 border-[#F0F0F0] font-montserrat`}>
                                        <div className='w-full font-semibold text-left p-4 md:p-5'>
                                            Products ({products.length})
                                        </div>

                                        {/* Grid Container */}
                                        <div className='w-full'>
                                            {/* Grid Header - Desktop only */}
                                            <div className='hidden md:grid md:grid-cols-12 gap-4 px-5 py-3 text-sm font-medium border-b'>
                                                <div className='col-span-5'>PRODUCT</div>
                                                <div className='col-span-2 text-center'>PRICE</div>
                                                <div className='col-span-3 text-center'>ITEMS</div>
                                                <div className='col-span-2 text-center'>SUBTOTAL</div>
                                            </div>

                                            {/* Products List */}
                                            <div className='w-full'>
                                                {products.map((pro, idx) => (
                                                    <div key={idx} className='border-b last:border-b-0'>
                                                        {/* Desktop Layout */}
                                                        <div className='hidden md:grid md:grid-cols-12 gap-4 px-5 py-4 items-center'>
                                                            <div className='col-span-5 flex items-center gap-3'>
                                                                <img
                                                                    src={pro.mainImage}
                                                                    alt={pro.itemName}
                                                                    className='w-16 h-20 object-cover rounded'
                                                                />
                                                                <div className='flex flex-col text-left'>
                                                                    <span className='text-[#2DA5F3] text-sm'>
                                                                        {pro.categoryName}
                                                                    </span>
                                                                    <span className='text-sm line-clamp-2'>
                                                                        {pro.itemName}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className='col-span-2 text-center'>Rs. {pro.rate}</div>
                                                            <div className='col-span-3 text-center'>{formatSizes(pro.size)}</div>
                                                            <div className='col-span-2 text-center font-medium'>Rs. {pro.totalRate}</div>
                                                        </div>

                                                        {/* Mobile Layout */}
                                                        <div className='md:hidden p-4'>
                                                            <div className='flex gap-3 mb-3'>
                                                                <img
                                                                    src={pro.mainImage}
                                                                    alt={pro.itemName}
                                                                    className='w-16 h-20 object-cover rounded flex-shrink-0'
                                                                />
                                                                <div className='flex-1'>
                                                                    <div className='text-[#2DA5F3] text-left text-sm mb-1'>
                                                                        {pro.categoryName}
                                                                    </div>
                                                                    <div className='text-sm text-left font-medium mb-3'>
                                                                        {pro.itemName}
                                                                    </div>
                                                                    <div className='flex justify-between text-sm mb-1'>
                                                                        <span>Price:</span>
                                                                        <span>Rs. {pro.rate}</span>
                                                                    </div>
                                                                    <div className='flex justify-between text-sm'>
                                                                        <span>Items:</span>
                                                                        <span className='text-right'>{formatSizes(pro.size)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='flex justify-between border-t pt-3 font-medium'>
                                                                <span>Subtotal:</span>
                                                                <span>Rs. {pro.totalRate}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="
                                            w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3
                                            gap-5
                                            divide-y sm:divide-y-0 sm:divide-x
                                            border-2 border-[#F0F0F0]
                                            font-montserrat md:py-5 text-left 
                                        "
                                    >

                                        <div className="flex flex-col gap-2 p-5 py-0">
                                            <div className="font-semibold text-[.9rem] underline mt-3 md:m-0">Billing Address</div>
                                            <div className="flex flex-col text-[.85rem] gap-1">
                                                <span className="font-semibold">{customer}</span>
                                                <span className="text-wrap break-words">{address}</span>
                                                <span className="font-semibold">{mobile}</span>
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-2 p-5 py-0">
                                            <div className="font-semibold text-[.9rem] underline mt-3 md:m-0">Shipping Address</div>
                                            <div className="flex flex-col text-[.85rem] gap-1">
                                                <span className="font-semibold">{customer}</span>
                                                <span className="text-wrap break-words">{address}</span>
                                                <span className="font-semibold">{mobile}</span>
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-2 p-4 rounded-md bg-gray-50 border border-gray-200">
                                            {/* <div className="font-semibold text-[.9rem] text-gray-700">
                                                📝 Order Notes
                                            </div> */}

                                            <p className="text-[.85rem] text-gray-600 leading-relaxed">
                                                Thanks for shopping with <span className="font-semibold text-gray-800">BlackBaton</span>!
                                                We truly appreciate your support and hope you enjoy your purchase.
                                            </p>
                                        </div>

                                    </div>

                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            <div className='h-max'>
                {isTab ? <FooterMob /> : <Footer />}

            </div>

            {updateAddressBox && (
                <div className='fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50'>
                    <div className='lg:w-1/2 w-full bg-white rounded-lg p-6 relative max-h-[90vh] overflow-y-auto'>
                        <button
                            onClick={() => setUpdateAddressBox(false)}
                            className='absolute top-2 right-2 bg-gray-200 hover:bg-gray-300 rounded-full w-8 h-8 flex items-center justify-center'
                        >
                            &times;
                        </button>

                        <div className='flex flex-col gap-4'>
                            <h2 className='text-xl font-bold text-gray-800'>EDIT ADDRESS</h2>
                            <hr className='border-gray-300' />

                            <h3 className='font-semibold text-gray-700'>CONTACT DETAILS</h3>

                            <div className='space-y-1'>
                                <label className='block text-sm font-medium text-gray-600'>
                                    Full Name *
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    // placeholder="Enter your full name"
                                    value={customer}
                                    disabled
                                    // onChange={handleChange}
                                    className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                    required
                                />
                            </div>

                            <div className='space-y-1'>
                                <label className='block text-sm font-medium text-gray-600'>
                                    Mobile Number *
                                </label>
                                <input
                                    type="text"
                                    name="mobile"
                                    // placeholder="10-digit mobile number"
                                    value={mobile}
                                    disabled
                                    // onChange={handleChange}
                                    className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                    maxLength="10"
                                    required
                                />
                            </div>

                            <h3 className='font-semibold text-gray-700 mt-4'>ADDRESS DETAILS</h3>

                            <div className='grid grid-cols-2 gap-4'>
                                <div className='space-y-1'>
                                    <label className='block text-sm font-medium text-gray-600'>
                                        Pincode *
                                    </label>
                                    <input
                                        type="text"
                                        name="pincode"
                                        // placeholder="6-digit pincode"
                                        value={formData.pincode}
                                        disabled
                                        // onChange={(e) => {
                                        //     handleChange(e);
                                        //     // fetchPinDetails(e.target.value);
                                        // }}
                                        className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                        maxLength="6"
                                        required
                                    />
                                </div>
                                <div className='space-y-1'>
                                    <label className='block text-sm font-medium text-gray-600'>
                                        Locality / Town
                                    </label>
                                    <input
                                        type="text"
                                        name="locality"
                                        // placeholder="Enter locality/town"
                                        value={formData.locality}
                                        onChange={handleChange}
                                        className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                    />
                                </div>
                            </div>

                            {/* 🔹 Separate Address Components with Labels */}
                            <div className='space-y-4 mt-2'>
                                <div className='grid grid-cols-2 gap-4'>
                                    <div className='space-y-1'>
                                        <label className='block text-sm font-medium text-gray-600'>
                                            House/Flat No. *
                                        </label>
                                        <input
                                            type="text"
                                            name="houseNo"
                                            // placeholder="e.g., 123, Flat 4A"
                                            value={formData.houseNo}
                                            onChange={handleChange}
                                            className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                            required
                                        />
                                    </div>
                                    <div className='space-y-1'>
                                        <label className='block text-sm font-medium text-gray-600'>
                                            Building/Apartment Name
                                        </label>
                                        <input
                                            type="text"
                                            name="buildingName"
                                            // placeholder="e.g., Sunshine Apartments"
                                            value={formData.buildingName}
                                            onChange={handleChange}
                                            className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                        />
                                    </div>
                                </div>



                                <div className='grid grid-cols-2 gap-4'>
                                    <div className='space-y-1'>
                                        <label className='block text-sm font-medium text-gray-600'>
                                            Street/Road Name
                                        </label>
                                        <input
                                            type="text"
                                            name="street"
                                            // placeholder="e.g., MG Road, Park Street"
                                            value={formData.street}
                                            onChange={handleChange}
                                            className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                        />
                                    </div>
                                    <div className='space-y-1'>
                                        <label className='block text-sm font-medium text-gray-600'>
                                            Landmark (Optional)
                                        </label>
                                        <input
                                            type="text"
                                            name="landmark"
                                            // placeholder="e.g., Near City Mall"
                                            value={formData.landmark}
                                            onChange={handleChange}
                                            className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                        />
                                    </div>
                                </div>

                                <div className='grid grid-cols-2 gap-4'>
                                    <div className='space-y-1'>
                                        <label className='block text-sm font-medium text-gray-600'>
                                            Area/Locality *
                                        </label>
                                        <input
                                            type="text"
                                            name="area"
                                            // placeholder="e.g., Koramangala, Bandra West"
                                            value={formData.area}
                                            onChange={handleChange}
                                            className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                            required
                                        />
                                    </div>
                                    <div className='space-y-1'>
                                        <label className='block text-sm font-medium text-gray-600'>
                                            City *
                                        </label>
                                        <input
                                            type="text"
                                            name="city"
                                            // placeholder="e.g., Mumbai, Bangalore"
                                            value={formData.city}
                                            disabled
                                            onChange={handleChange}
                                            className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='grid grid-cols-2 gap-4 mt-2'>
                                <div className='space-y-1'>
                                    <label className='block text-sm font-medium text-gray-600'>
                                        District *
                                    </label>
                                    <input
                                        type="text"
                                        name="district"
                                        // placeholder="e.g., South Delhi, Bengaluru Urban"
                                        value={formData.district}
                                        disabled
                                        onChange={handleChange}
                                        className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                        required
                                    />
                                </div>
                                <div className='space-y-1'>
                                    <label className='block text-sm font-medium text-gray-600'>
                                        State *
                                    </label>
                                    <input
                                        type="text"
                                        name="state"
                                        // placeholder="e.g., South Delhi, Bengaluru Urban"
                                        value={formData.state}
                                        disabled
                                        onChange={handleChange}
                                        className='w-full h-[40px] border border-gray-300 px-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'
                                        required
                                    />
                                </div>
                            </div>

                            {/* <div className='mt-4'>
                                <h4 className='font-semibold text-gray-700 mb-3'>ADDRESS TYPE</h4>
                                <div className='flex gap-6'>
                                    <label className='flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-gray-300 hover:bg-gray-50 w-1/2'>
                                        <input
                                            type="radio"
                                            name="addressType"
                                            value="Home"
                                            checked={formData.addressType === 'Home'}
                                            onChange={handleChange}
                                            className='w-5 h-5 text-blue-600'
                                        />
                                        <div>
                                            <span className='font-medium text-gray-700'>Home</span>
                                            <p className='text-xs text-gray-500'>Residential address</p>
                                        </div>
                                    </label>
                                    <label className='flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-gray-300 hover:bg-gray-50 w-1/2'>
                                        <input
                                            type="radio"
                                            name="addressType"
                                            value="Office"
                                            checked={formData.addressType === 'Office'}
                                            onChange={handleChange}
                                            className='w-5 h-5 text-blue-600'
                                        />
                                        <div>
                                            <span className='font-medium text-gray-700'>Office</span>
                                            <p className='text-xs text-gray-500'>Workplace address</p>
                                        </div>
                                    </label>
                                </div>
                            </div> */}

                            <div className='flex gap-4 mt-8'>
                                <button
                                    onClick={handleUpdateAddress}
                                    className='flex-1 h-[48px] bg-black text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
                                >
                                    Update Address
                                </button>
                                <button
                                    onClick={() => setUpdateAddressBox(false)}
                                    className='flex-1 h-[48px] border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors'
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    );
};

export default DelhiveryTrackingComponent;

